module.exports = __webpack_public_path__ + "img/picMain_2.aab590b2.png";